<template>
  <Shoppingcart />
</template>

<script>
import Shoppingcart from "./components/Shoppingcart.vue";
export default {
  components: {
    Shoppingcart,
  },
};
</script>

<style></style>
